import React from 'react'
import { useTranslation } from 'react-i18next'
import "./contact.css"

const LeftContact = () => {
   const {t} = useTranslation()
  return (
    <div className=''>
    {/* <Contact/> */}
    <div className="form-container border-y-8   border border-[#0000ff] hover:scale-105  hover:shadow-2xl hover:shadow-white shadow-inner-white ">
    <div className="form ">
      <span className="heading text-center font-serif font-bold  ">{t("Contact2")}</span>
      
      <input placeholder={t("name")} type="text" className="input" />
      <input placeholder={t("Email")} id="mail" type="email" className="input" />
      <textarea placeholder={t("Say")} rows={10} cols={30} id="message" name="message" className="textarea" defaultValue={""} />
      <div className="button-container">
        <div className="send-button font-serif">Send</div>
        <div className="reset-button-container">
          <div id="reset-btn" className="reset-button font-serif">Reset</div>
        </div>
      </div>

    </div>
  </div>
    </div> 
  )
}

export default LeftContact
